/**
 *  运营规则
 * */
import React from 'react';
import PropTypes from 'prop-types';
import Main from './pages/main';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';


class OperatingRule extends React.PureComponent {

    componentDidMount() {
        const { setBreadcrumbPaths, match } = this.props;
        setBreadcrumbPaths(match); // 自动识别面包屑
    }

    // 更新界面
    _updateContent = (mode, value) => {
        const { history, } = this.props;
        switch (mode) {
            case 'CREAT':
                history.push({
                    pathname: '/home/system/operatingrule/createInfo',
                });
                break;
            case 'EDITOR':
                history.push({
                    pathname: '/home/system/operatingrule/editInfo/' + value,
                });
                break;
        }
    }

    render() {
        return (
            <Main updateContent={this._updateContent} history={this.props.history} />
        );
    }
}

OperatingRule.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,//面包屑导航信息
};

export default connect(null, { setBreadcrumbPaths })(OperatingRule);